import React, { useEffect, useState } from 'react';
import HomeFourMain from './HomeFourMain';
import FooterStyleFour from '../../components/Layout/Footer/FooterStyleFour';
import HeaderStyleFour from '../../components/Layout/Header/HeaderStyleFour';
import BackToTop from '../../components/elements/BackToTop';

const HomeFour = () => {
	const [isVisible, setIsVisible] = useState(false);

    const handleScroll = () => {
        const scrollTop = window.scrollY;
        if (scrollTop > 300) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

	return (
		<div className="homestyle2">
		<React.Fragment>
			
            <HeaderStyleFour />
            <HomeFourMain/>
            <BackToTop scroll={isVisible} />
            <FooterStyleFour />
		</React.Fragment>
		</div>
	);
}

export default HomeFour;
